<template>
  <div id="records">
    <a-spin :spinning="spinLoading">
      <div class="search-form ant-round-form">
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_receipt_102') }}: </span>
          <!-- date picker -->
          <a-range-picker
            v-model:value="dateOpts"
            format="YYYY/MM/DD"
            @change="handleDateChange"
          />
          <span v-if="dateRangeError" class="date-range-error">
            {{ $t('date_range_limit_month') }}
          </span>
        </div>
      </div>
      <div class="op-part">
        <div class="edit-btn">
          <a-button
            shape="round"
            class="btn-success"
            style="margin-right: auto"
            :loading="exporting"
            @click="exportAlert()"
          >
            <template #icon><bars-outlined /></template>
            {{ exporting ? $t('pages_receipt_099') : $t('pages_receipt_098') }}
          </a-button>
        </div>
      </div>
      <div class="table-part">
        <a-table
          :scroll="{ x: 1200 }"
          :loading="loading"
          :pagination="false"
          :custom-header-row="() => { return {class: 'my-table-tr'}}"
          :columns="columns"
          :data-source="records"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'edit' && !record.preDisputeDecision">
              <a-button
                shape="round"
                size="small"
                class="btn-primary-empty-0"
                @click="showDecision(record)"
              >{{ $t('pages_receipt_074') }}</a-button>
            </template>
          </template>
        </a-table>
        <table-page
          :total="total"
          :page-opts="searchQuery"
          @update-page="updatePage"
        />
      </div>
    </a-spin>
    <ethoca-decision
      ref="ethocaDecisionRef"
      v-model:visible="decisionVisible"
      @update:records="loadRecords"
    />
  </div>
</template>

<script>
import EthocaDecision from './ethoca-decision.vue'
import TablePage from '@/components/table-page'
// import OrderDetail from './order-detail'
import { reactive, toRefs, ref } from 'vue'
import { _order } from '@/api'
import { parseMoney } from '@/util'
// import { parseMoney } from '@/util'
import i18n from '@/locale'
import moment from 'moment'
import { message } from 'ant-design-vue'
export default {
  name: 'EthocaRecords',
  components: {
    'table-page': TablePage,
    'ethoca-decision': EthocaDecision
    // 'order-detail': OrderDetail
  },
  props: {

  },
  setup (props) {
    const ethocaDecisionRef = ref(null)
    const dateOpts = ref(null)
    const dateRangeError = ref(false)

    const handleDateChange = (dates) => {
      if (dates && dates.length === 2 && dates[0] && dates[1]) {
        const startDate = dates[0]
        const endDate = dates[1]
        const maxEndDate = moment(startDate).add(1, 'month')

        // 检查是否超过一个月
        if (endDate.isAfter(maxEndDate)) {
          dateRangeError.value = true
          // 自动调整结束日期
          dateOpts.value = [startDate, maxEndDate]
        } else {
          dateRangeError.value = false
          loadRecords()
        }
      }
    }

    const exportAlert = async () => {
      if (dateRangeError.value || !dateOpts.value || dateOpts.value.length !== 2) {
        // show error message
        message.error(i18n.global.t('pages_nuvei_001'))
        return
      }

      state.exporting = true
      const query = {
        eventStartDate: new Date(dateOpts.value[0]).getTime(),
        eventEndDate: new Date(dateOpts.value[1]).getTime()
      }
      await _order.exportEthocaAlert(query)
      state.exporting = false
    }

    const state = reactive({
      loading: true,
      exporting: false,
      decisionVisible: false,
      spinLoading: false,
      total: 0,
      searchQuery: {
        pageNum: 1,
        pageSize: 10,
        merchantOrderNo: null
      },
      records: [],
      columns: [
        { key: 'eventId', dataIndex: 'eventId', title: i18n.global.t('pages_receipt_055'), width: 180, ellipsis: true },
        { key: 'eventDateUtc', dataIndex: 'eventDateUtc', title: i18n.global.t('pages_receipt_056'), width: 180 },
        { key: 'eventCorrelationId', dataIndex: 'eventCorrelationId', title: i18n.global.t('pages_receipt_057'), width: 180, ellipsis: true },
        { key: 'ethocaId', dataIndex: 'ethocaId', title: i18n.global.t('pages_receipt_058'), width: 180 },
        { key: 'ethocaMemberId', dataIndex: 'ethocaMemberId', title: i18n.global.t('pages_receipt_059'), width: 180 },
        { key: 'ethocaMemberName', dataIndex: 'ethocaMemberName', title: i18n.global.t('pages_receipt_060'), width: 180, ellipsis: true },
        { key: 'issuer', dataIndex: 'issuer', title: i18n.global.t('pages_receipt_061'), width: 180 },
        { key: 'arn', dataIndex: 'arn', title: i18n.global.t('pages_receipt_062'), width: 180 },
        { key: 'chargebackAmount', dataIndex: 'chargebackAmount', title: i18n.global.t('pages_receipt_063'), width: 150 },
        { key: 'maskedCreditCard', dataIndex: 'maskedCreditCard', title: i18n.global.t('pages_receipt_103'), width: 180 },
        // { key: 'chargebackCurrency', dataIndex: 'chargebackCurrency', title: i18n.global.t('pages_receipt_064'), width: 100 },
        { key: 'merchantDescriptor', dataIndex: 'merchantDescriptor', title: i18n.global.t('pages_receipt_065'), width: 180 },
        { key: 'transactionId', dataIndex: 'transactionId', title: i18n.global.t('pages_receipt_066'), width: 180 },
        { key: 'creditCardBin', dataIndex: 'creditCardBin', title: i18n.global.t('pages_receipt_067'), width: 180 },
        { key: 'authTransactionDate', dataIndex: 'authTransactionDate', title: i18n.global.t('pages_receipt_068'), width: 180 },
        { key: 'chargebackReasonCode', dataIndex: 'chargebackReasonCode', title: i18n.global.t('pages_receipt_069'), width: 100 },
        { key: 'transactionAmount', dataIndex: 'transactionAmount', title: i18n.global.t('pages_receipt_070'), width: 150 },
        // { key: 'transactionCurrency', dataIndex: 'transactionCurrency', title: i18n.global.t('pages_receipt_071'), width: 100 },
        { key: 'fee', dataIndex: 'fee', title: i18n.global.t('pages_receipt_072'), width: 150 },
        // { key: 'feeCurrency', dataIndex: 'feeCurrency', title: i18n.global.t('pages_receipt_073'), width: 100 },
        { key: 'preDisputeDecision', dataIndex: 'preDisputeDecision', title: i18n.global.t('pages_receipt_075'), width: 100 },
        { key: 'refundIndicator', dataIndex: 'refundIndicator', title: i18n.global.t('pages_receipt_076'), width: 100 },
        { key: 'edit', title: i18n.global.t('common_text_001'), align: 'center', fixed: 'right', width: 120 }
      ]
    })

    const updatePage = (page, pageSize) => {
      state.searchQuery.pageNum = page
      state.searchQuery.pageSize = pageSize
      loadRecords()
    }

    const loadRecords = async (pageNum) => {
      state.loading = true
      if (pageNum) state.searchQuery.pageNum = pageNum
      const query = Object.assign({}, state.searchQuery, {
        pageNo: state.searchQuery.pageNum,
        pageSize: state.searchQuery.pageSize
        // queryStartTime: state.searchQuery.queryStartTime ? new Date(state.searchQuery.queryStartTime).getTime() : null,
        // queryEndTime: state.searchQuery.queryEndTime ? new Date(state.searchQuery.queryEndTime).getTime() : null
      })
      const res = await _order.getEthocaNotifyList(query)
      console.log('res', res)
      if (res.data.succ) {
        state.records = res.data.data.list.map(item => {
          return Object.assign({}, item, {
            eventDateUtc: moment(item.eventDateUtc).format('YYYY-MM-DD HH:mm:ss'),
            chargebackAmount: parseMoney(item.chargebackAmount) + ' ' + item.chargebackCurrency,
            transactionAmount: parseMoney(item.transactionAmount) + ' ' + item.transactionCurrency,
            fee: item.fee != null ? parseMoney(item.fee) + ' ' + item.feeCurrency : ' ',
            authTransactionDate: moment(item.authTransactionDate).format('YYYY-MM-DD HH:mm:ss')
          })
        })
        console.log('state.records', state.records)
        state.total = res.data.data.total
      }
      state.loading = false
    }

    const init = () => {
      loadRecords()
    }

    const showDecision = (record) => {
      ethocaDecisionRef.value.updateRecord(record)
      state.decisionVisible = true
    }

    init()

    return {
      updatePage,
      loadRecords,
      showDecision,
      ethocaDecisionRef,
      dateRangeError,
      dateOpts,
      handleDateChange,
      exportAlert,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#orderToday {
  .table-part {
    margin-top: 12px;
  }
}

.op-part {
  display: flex;
  justify-content: flex-end;
  margin: 12px;
}
.date-range-error {
  color: red;
}
</style>
